export default "__VITE_ASSET__0d80de7e__"